import React from "react";

function AddIcon() {
  return (
    <>
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.79167 6.04167H0V4.79167H4.79167V0H6.04167V4.79167H10.8333V6.04167H6.04167V10.8333H4.79167V6.04167Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export default AddIcon;
